import React, { useState, useEffect } from 'react';
import CloseButton from '../../../../sharecomponents/CloseButton.jsx';
import { dateFormatConDiaYHoraShort, dateFormatConDia } from '../../../../../utils/DateFunctions.jsx';

const DetallesAplicacionDeRefuerzos = (p) => {
    const close = p.close ?? (() => { });
    const { camas_ocupadas, fertilizante_ceil, fertilizante_exacto, valvula, rancho, } = p.data ?? { aplicacion: { aplicaciones: [] } }
    const { aplicadosTotales, aplicaciones } = (p.data ?? { aplicacion: { aplicaciones: [] } }).aplicacion;
    const [aplicacionesFiltradas, setaplicacionesFiltradas] = useState([]);
    var counter = 0;
    useEffect(() => {
        filtrarCamas();
    }, []);

    const keyGen = () => { counter++; return counter + "lista detalles keygen"; }

    const usuariosEjecutores = () => {
        let len = aplicaciones.length;
        let usuariosSet = new Set();
        for (let i = 0; i < len; i++) {
            if (!aplicaciones[i].refuerzo) continue;
            usuariosSet.add(aplicaciones[i].refuerzo.usuario_nombre);
        }
        return Array.from(usuariosSet);
    }

    const filtrarCamas = (filtroUsuario = "") => {
        let camasFiltradas = [];
        let len = aplicaciones.length;
        for (let i = 0; i < len; i++) {
            if (!aplicaciones[i].refuerzo) continue;
            if (filtroUsuario !== "" && aplicaciones[i].refuerzo.usuario_nombre !== filtroUsuario) continue;
            camasFiltradas.push(aplicaciones[i]);
        }
        setaplicacionesFiltradas(camasFiltradas);
    }

    return (
        <div className='vw-100 vh-100 blur-l p-2 contenedor' style={{ position: 'fixed', top: 0, left: 0, zIndex: 50 }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <CloseButton close={() => close()} floatElement={true} />
                <div className='bw-1200 gradient-grey-light shadow-multi round-s p-2' style={{ height: "90vh", overflow: "auto" }}>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='w-100 h4 text-300 text-center'>{valvula} - <span className='text-m text-bold'>{rancho}</span></div>
                        <div className='w-70 border-bottom border-warning'></div>

                        <div className='w-100 blur-l bg-white5' style={{ position: "sticky", top: 0, zIndex: 2 }}>
                            <div className='row justify-content-evenly w-100 m-0 p-0'>
                                <div className='bw-300 bg-white3 round-m'>
                                    <div className='w-100 text-center text-s text-bold'>Filtrar por usuario</div>
                                    <select className='form-control form-control-sm shadow border boder-3' onChange={(e) => filtrarCamas(e.target.value)}>
                                        <option value='' >Todos los usuarios</option>
                                        {usuariosEjecutores().map((usuario) => <option key={keyGen()} value={usuario}>{usuario}</option>)}
                                    </select>
                                </div>
                                <div className='bw-300 contenedor h4 text-300 bg-white3 round-m'>
                                    Camas: {aplicacionesFiltradas.length}
                                </div>
                            </div>
                        </div>

                        <div className='w-100' />

                        {aplicacionesFiltradas.map((aplicacion) =>
                            <div key={keyGen()} className='bw-1100 p-0 round-m shadow-sm border mt-2 mb-3 bg-white'>
                                <div className='row justify-content-evenly w-100 m-0 p-0'>
                                    <div className='w-100 text-start h4 text-bold round-top-m bg-black3 text-white'>
                                        <span className='text-m text-300 me-2'>Cama</span>{aplicacion.cama}
                                        <div className='w-80 border-bottom border-info'></div>
                                    </div>
                                    <div className='bw-250 border-bottom'>
                                        <div className='w-100 text-s text-bold'>Refuerzo aplicado por</div>
                                        <div className='w-100 text-m text-300'>{aplicacion.refuerzo.usuario_nombre.toUpperCase()}</div>
                                    </div>

                                    <div className='bw-250 border-bottom'>
                                        <div className='w-100 text-s text-bold'>Fecha y hora de registro</div>
                                        <div className='w-100 text-m text-300'>{dateFormatConDiaYHoraShort(aplicacion.refuerzo.creado)}</div>
                                    </div>

                                    <div className='bw-250 border-bottom'>
                                        <div className='w-100 text-s text-bold'>Fecha programada</div>
                                        <div className='w-100 text-m text-300'>{dateFormatConDia(aplicacion.refuerzo.fecha_aplicacion)}</div>
                                    </div>
                                    <div className='bw-150 border-bottom'>
                                        <div className='w-100 text-s text-bold'>Folio de aplicación</div>
                                        <div className='w-100 text-m text-300'>{aplicacion.refuerzo.id}</div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default DetallesAplicacionDeRefuerzos;